import {
  createTask as publicCreateTask,
  listTasks as publicListTasks,
  getTask as publicGetTask,
  cancelTask as publicCancelTask,
} from './data-autocms-v2-background-task-tasks.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { BuildRESTFunction, MaybeContext } from '@wix/sdk-types';

export const createTask: MaybeContext<
  BuildRESTFunction<typeof publicCreateTask> & typeof publicCreateTask
> = /*#__PURE__*/ createRESTModule(publicCreateTask);
export const listTasks: MaybeContext<
  BuildRESTFunction<typeof publicListTasks> & typeof publicListTasks
> = /*#__PURE__*/ createRESTModule(publicListTasks);
export const getTask: MaybeContext<
  BuildRESTFunction<typeof publicGetTask> & typeof publicGetTask
> = /*#__PURE__*/ createRESTModule(publicGetTask);
export const cancelTask: MaybeContext<
  BuildRESTFunction<typeof publicCancelTask> & typeof publicCancelTask
> = /*#__PURE__*/ createRESTModule(publicCancelTask);

export {
  Type,
  Status,
  Environment,
  Operation,
  WebhookIdentityType,
} from './data-autocms-v2-background-task-tasks.universal.js';
export {
  Task,
  TaskOptionsOneOf,
  ApplicationError,
  DeleteByQueryOptions,
  PublishPluginOptions,
  CopyFieldDataOptions,
  EditFieldDataOptions,
  Replace,
  Operations,
  UpdatePublishStatusOptions,
  UpdatePublishStatusOptionsOptionsOneOf,
  ScheduleOperation,
  CreateTaskRequest,
  CreateTaskResponse,
  ListTasksRequest,
  Paging,
  ListTasksResponse,
  PagingMetadataV2,
  Cursors,
  GetTaskRequest,
  GetTaskResponse,
  CancelTaskRequest,
  CancelTaskResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  ListTasksOptions,
} from './data-autocms-v2-background-task-tasks.universal.js';
export {
  TypeWithLiterals,
  StatusWithLiterals,
  EnvironmentWithLiterals,
  OperationWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './data-autocms-v2-background-task-tasks.universal.js';
